module.exports = __webpack_public_path__ + "static/media/account-bg.e666bc5e.png";